import { CreatorServiceCategory } from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import { $t } from "@/lib/i18nHelpers";
import { ListFields } from "@/types";
import { CreatorServiceTag } from "@/features/CreatorService/types";

export const CreatorServiceCategoryNamesMap: Record<string, ReturnType<typeof $t>> = {
  [CreatorServiceCategory.CHAT_MESSAGING]: $t("Chat & Messaging"),
  [CreatorServiceCategory.PHOTOS_MEDIA]: $t("Photos & Media"),
  [CreatorServiceCategory.VIDEOS_SHOWS]: $t("Videos & Shows"),
  [CreatorServiceCategory.CALLS_LIVE]: $t("Calls & Live"),
  [CreatorServiceCategory.CUSTOM_CONTENT]: $t("Custom Content"),
  [CreatorServiceCategory.VIP_BUNDLES]: $t("VIP / Bundles"),
};

export const CATEGORIES_OPTIONS: ListFields = Object.entries(CreatorServiceCategoryNamesMap).map(([value, text]) => ({
  value,
  text,
}));

export const CREATOR_SERVICE_TAGS: CreatorServiceTag[] = [
  { id: "1", icon: "⚡️", text: $t("Instant delivery") },
  { id: "2", icon: "🟢", text: $t("Available now") },
  { id: "3", icon: "🕛", text: $t("Within 24h") },
  { id: "4", icon: "📩", text: $t("On request") },
  { id: "5", icon: "🤝", text: $t("To be arranged") },
  { id: "6", icon: "⭐️", text: $t("Most popular") },
  { id: "7", icon: "🔥", text: $t("Best seller") },
  { id: "8", icon: "👑", text: $t("Fan favorite") },
  { id: "9", icon: "💎", text: $t("Premium") },
  { id: "10", icon: "✨", text: $t("Exclusive") },
  { id: "11", icon: "🔒", text: $t("Private access") },
  { id: "12", icon: "👁️‍🗨️", text: $t("Custom") },
  { id: "13", icon: "🎥", text: $t("Live experience") },
  { id: "14", icon: "📸", text: $t("Photo set") },
];
